import patientService from '../services/patient.service';

const patients = {
    namespaced: true,
    state: {
        patientTypes: null,
    },
    actions: {
        //CREATE
        create(_, formData) {
            return patientService.create(formData);
        },

        //READ
        getpage(_, params) {
            return patientService.getpage(params.id, params.urlParameters, params.requestId);
        },
        get(_, params) {
            return patientService.get(params.id, params.requestId);
        },
        getOne(_, id) {
            return patientService.getOne(id);
        },
        async getTypes({commit, state, getters}) {
            if (state.patientTypes === null) {
                var response = await patientService.getTypes();
                commit('setPatientTypes', response.data);
            }
            return getters.patientTypes;
        },
        getageingmanagement(_, params) {
            return patientService.getageingmanagement(params.urlParameters);
        },
        //UPDATE
        update(_, params) {
            return patientService.update(params.id, params.formData);
        },
        medikreditadd(_, id) {
            return patientService.medikreditadd(id);
        },
        
        //DELETE
        delete(_, id) {
            return patientService.delete(id);
        },
    },
    getters: {
        patientTypes: (state) => state.patientTypes,
    },
    mutations: {
        setPatientTypes(state, types) {
            state.patientTypes = types;
        },
    },
};

export default patients;
